/*! pdp-polish-1005 (B6-8 PDP polish), deferred after blazin.js, ux02, ux07, b66, b67.
   1) Chat tuck over option buttons: same idea as blazin.js bz-chat-tuck (which only checks ATC/cart CTAs).
      Adds html.bz-chat-tuck-opt while a VISIBLE .option-btn sits under the Shopify Inbox bubble.
      CSS hides shopify-chat:not([open]) only; an open chat window is never hidden. No offsets change.
   2) ?variant= sync: after blazin.js resolves #variant-id on an .option-btn click, history.replaceState
      sets ?variant=<id>, keeping other params and the hash. Selection logic is not touched. */
(function () {
  "use strict";
  var root = document.documentElement;
  var idEl = document.getElementById("variant-id");
  var hasOptions = !!document.querySelector(".product-options .option-btn");
  if (!hasOptions) return;

  function syncUrl() {
    if (!idEl || !window.history || !history.replaceState || !window.URL) return;
    var id = String(idEl.value || "").trim();
    if (!/^\d+$/.test(id)) return;
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get("variant") === id) return;
      u.searchParams.set("variant", id);
      history.replaceState(history.state, "", u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  var raf = 0;
  function bubbleRect(chat) {
    var a = chat.shadowRoot && chat.shadowRoot.querySelector('.activator, [part~="activator"]');
    if (a) {
      var r = a.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return r;
    }
    return null;
  }
  function check() {
    raf = 0;
    var chat = document.querySelector("shopify-chat");
    if (!chat) return;
    var b = bubbleRect(chat);
    if (!b) { root.classList.remove("bz-chat-tuck-opt"); return; }
    var pad = 8, hit = false;
    var btns = document.querySelectorAll(".product-options .option-btn");
    for (var i = 0; i < btns.length && !hit; i++) {
      var r = btns[i].getBoundingClientRect();
      if (!r.width || !r.height) continue;
      if (r.left < b.right + pad && r.right > b.left - pad && r.top < b.bottom + pad && r.bottom > b.top - pad) hit = true;
    }
    root.classList.toggle("bz-chat-tuck-opt", hit);
  }
  function queue() { if (!raf) raf = requestAnimationFrame(check); }

  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest(".option-btn")) {
      setTimeout(function () { syncUrl(); queue(); }, 0);
    }
  });
  window.addEventListener("scroll", queue, { passive: true });
  window.addEventListener("resize", queue);
  window.addEventListener("load", queue);
  setTimeout(queue, 1500);
  setTimeout(queue, 4000);
  queue();
})();